import React from 'react';
import moment from 'moment';
import { FormattedMessage, useIntl } from 'react-intl';
import get from 'lodash/get';
import { ensureTransaction } from '../../../util/data';
import { propTypes, RentalType } from '../../../util/types';
import { types as sdkTypes } from '../../../util/sdkLoader';
import { getBookingStatus } from './adminTxHelpers';
import { formatMoney } from '../../../util/currency';
import { formatBondStatus } from '../../../util/transaction';
import css from './SummarySection.css';
import { NamedLink } from '../../../components';

const { Money } = sdkTypes;

const SummarySection = ({ transaction: tx }) => {
  const intl = useIntl();
  const transaction = ensureTransaction(tx);
  const { id, attributes, booking } = transaction;
  const { processName, protectedData = {}, metadata = {} } = attributes;
  const { bondFee } = protectedData;
  const { bondStatus } = metadata;
  const { displayStart, displayEnd, seats } = get(booking, 'attributes', {});
  const displayStartMoment = moment(displayStart);
  const displayEndMoment = moment(displayEnd);
  const isSamedDate = displayStartMoment.isSame(displayEndMoment, 'date');
  const bookingPeriod = `${displayStartMoment.format('ddd, MMM DD, h:mm a').toString()} - ${
    isSamedDate
      ? displayEndMoment.format('h:mm a').toString()
      : displayEndMoment.format('ddd, MMM DD, h:mm a').toString()
  }`;
  const bookingStatus = getBookingStatus(intl, transaction);

  return (
    <div className={css.summary}>
      <h2 className={css.sectionTitle}>
        <FormattedMessage id="AMTxPage.summary" defaultMessage="Summary" />
      </h2>
      <div className={css.sectionContent}>
        <div className={css.summaryItem}>
          <div className={css.summaryItemTitle}>
            <FormattedMessage id="AMTxPage.bookingType" defaultMessage="Booking type" />
          </div>
          <div className={css.summaryItemContent}>{RentalType[processName]}</div>
        </div>
        <div className={css.summaryItem}>
          <div className={css.summaryItemTitle}>
            <FormattedMessage id="AMTxPage.bookingStatus" defaultMessage="Booking period" />
          </div>
          <div className={css.summaryItemContent}>{bookingStatus}</div>
        </div>
        {bondFee && bondStatus && (
          <div className={css.summaryItem}>
            <div className={css.summaryItemTitle}>
              <FormattedMessage id="AMTxPage.bondStatus" defaultMessage="Bond fee status" />
            </div>
            <div className={css.summaryItemContent}>
              {formatBondStatus(bondStatus || '')} (
              {formatMoney(intl, new Money(bondFee.amount, bondFee.currency))})
            </div>
          </div>
        )}
        <div className={css.summaryItem}>
          <div className={css.summaryItemTitle}>
            <FormattedMessage id="AMTxPage.bookingPeriod" defaultMessage="Booking period" />
          </div>
          <div className={css.summaryItemContent}>{bookingPeriod}</div>
        </div>
        <div className={css.summaryItem}>
          <div className={css.summaryItemTitle}>
            <FormattedMessage id="AMTxPage.seats" defaultMessage="Seats" />
          </div>
          <div className={css.summaryItemContent}>{seats}</div>
        </div>
        <div className={css.summaryItem}>
          <div className={css.summaryItemTitle}>
            <FormattedMessage id="AMTxPage.transactionId" defaultMessage="Transction id" />
          </div>
          <NamedLink
            className={css.summaryItemContent}
            name="AdminManageTransactionsPage"
            to={{ search: `transactionId=${id && id.uuid}` }}
          >
            {transaction?.id?.uuid}
          </NamedLink>
        </div>
        <div className={css.summaryItem}>
          <div className={css.summaryItemTitle}>
            <FormattedMessage
              id="AMTxPage.transactionProcess"
              defaultMessage="Transction process"
            />
          </div>
          <div className={css.summaryItemContent}>{processName}</div>
        </div>
        <div className={css.summaryItem}>
          <div className={css.summaryItemTitle}>
            <FormattedMessage id="AMTxPage.seats" defaultMessage="Seats" />
          </div>
          <div className={css.summaryItemContent}>{seats}</div>
        </div>
      </div>
    </div>
  );
};

SummarySection.propTypes = {
  transaction: propTypes.transaction,
};

export default SummarySection;
